import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { fromDeviceDetector } from '../data-access/store/device-detector.selectors';

/**
 * A facade service that provides reactive signals for detecting various device properties such as type, browser, and operating system.
 * This service utilizes the Angular Store and RxJS interop for efficient state management and reactivity.
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorFacade {
  readonly #store = inject(Store);

  readonly isMobile = this.#store.selectSignal(fromDeviceDetector.selectIsMobile);
  readonly isDesktop = this.#store.selectSignal(fromDeviceDetector.selectIsDesktop);

  readonly isSafari = this.#store.selectSignal(fromDeviceDetector.selectIsSafari);
  readonly isFirefox = this.#store.selectSignal(fromDeviceDetector.selectIsFirefox);

  readonly isIOS = this.#store.selectSignal(fromDeviceDetector.selectIsIOS);
  readonly isIOSNative = this.#store.selectSignal(fromDeviceDetector.selectIsIOSNative);
  readonly isAndroidNative = this.#store.selectSignal(fromDeviceDetector.selectIsAndroidNative);

  readonly isMobileOS = this.#store.selectSignal(fromDeviceDetector.selectIsMobileOS);

  readonly isMacOs = this.#store.selectSignal(fromDeviceDetector.selectIsMacOs);
}
